"use client";

import React from "react";
import { Star } from "lucide-react";
import { motion } from "framer-motion";
import { Card, CardContent } from "@/components/ui/card";
interface TestimonialItem {
  id: number;
  quote: string;
  name: string;
  title: string;
  rating: number;
}
const testimonialsData: TestimonialItem[] = [{
  id: 1,
  quote: "ربطنا KTEX بـ 5 موردين جدد في أسبوعين. احترافية وسرعة عالية جداً.",
  name: "Client Name 1",
  title: "Professional Title, Company Name",
  rating: 5
}, {
  id: 2,
  quote: "مكتب التداول 24/7 يعني لا نفقد فرصة واحدة. موصى به بشدة لأي بائع أو مشتري.",
  name: "Client Name 2",
  title: "Professional Title, Company Name",
  rating: 5
}, {
  id: 3,
  quote: "معرفة KTEX بالسوق ساعدتنا في التفاوض على شروط أفضل. قيمة مضافة حقيقية.",
  name: "Client Name 3",
  title: "Professional Title, Company Name",
  rating: 5
}, {
  id: 4,
  quote: "في 3 أشهر، ساعدتنا KTEX في إغلاق 8 صفقات بملايين الدولارات. غيّرت اللعبة.",
  name: "Client Name 4",
  title: "Professional Title, Company Name",
  rating: 5
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.22, 1, 0.36, 1]
    }
  }
};
export default function Testimonials() {
  return <section id="testimonials" data-nav="light" className="relative bg-background text-foreground py-15 md:py-[60px]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Bilingual Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        ease: [0.22, 1, 0.36, 1]
      }} className="text-center mb-10 md:mb-12">
          <h2 className="text-2xl sm:text-3xl md:text-[32px] font-bold text-primary tracking-tight mb-3">
            آراء عملائنا | What Our Clients Say
          </h2>
          <p className="text-base sm:text-lg text-muted-foreground max-w-2xl mx-auto mb-0 font-medium">
            شركات عالمية تثق بـ KTEX | Global Companies Trust KTEX
          </p>
        </motion.div>

        {/* Testimonials Grid */}
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.2
      }} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-[30px]">
          {testimonialsData.map((item, index) => <motion.div key={item.id} data-index={index} variants={itemVariants} whileHover={{
          y: -4
        }} transition={{
          duration: 0.2,
          ease: "easeOut"
        }} className="h-full">
              <Card className="h-full bg-card border-border/60 shadow-xs hover:shadow-md transition-shadow duration-300 rounded-lg p-[30px] flex flex-col justify-between">
                <CardContent className="p-0 flex flex-col h-full justify-between gap-5">
                  {/* Rating Stars */}
                  <div className="flex items-center gap-1 text-accent">
                    {Array.from({
                  length: item.rating
                }).map((_, starIndex) => <Star key={starIndex} className="size-4.5 fill-current" aria-hidden="true" />)}
                    <span className="sr-only">{item.rating} out of 5 stars</span>
                  </div>

                  {/* Arabic Quote */}
                  <blockquote dir="rtl" className="text-foreground/85 text-sm sm:text-base leading-relaxed grow font-normal text-right">
                    "{item.quote}"
                  </blockquote>

                  {/* Client Details */}
                  <div className="pt-4 border-t border-border/40">
                    <p className="text-sm font-bold text-foreground/80 mb-0.5">
                      {item.name}
                    </p>
                    <p className="text-xs text-muted-foreground mb-0">
                      {item.title}
                    </p>
                  </div>
                </CardContent>
              </Card>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}